import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'; // Import useParams
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, CircularProgress
} from '@mui/material';

const CompanyEdit = ({ match }) => {
    const recordId = match.params.id; // Assuming you're using React Router
    const history = useHistory();
    const [pinCodes, setPinCodes] = useState([]);
    const { isAuthenticated, companyId, permissions, isSuperAdmin, superCompanyId, logout, token, userId } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId]);

    const [formData, setFormData] = useState([]);

    useEffect(() => {
        fetchData('CompanyApi', `/CompanyDetails/${companyId}`, token)//, token
            .then((response) => {
                if (response.responseCode == '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Company Details:', error);
            });
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value === 'true' ? true : e.target.type === 'checkbox' ? e.target.checked : value,
        }));
    };


    const handleSubmit = event => {
        event.preventDefault();

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        updateData('CompanyApi', `${companyId}`, formData, token)//, token
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const phoneNumberPattern = /^\d{10}$/;
    const emailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;

    return (

        <div className="w-full max-w-sm container mx-auto" style={{ minWidth: '101%', marginTop: '-20px', padding: '20px', borderRadius: '10px', backgroundColor: '#f9f9f9' }}>
            <div className='w-full mb-2 flex'>
                <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Company</h6>
                {/* <Button
                    style={{
                        background: '#5CB338',
                        color: 'white',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                    }}
                    onClick={handleSubmit}
                >
                    Update
                </Button>

                <Button
                    component={Link}
                    to="/Home"
                    error
                    className="linkcolor"
                    style={{
                        background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                        color: 'white',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                    }}
                >
                    Cancel
                </Button> */}
                <div className="flex items-center gap-4 mt-2 md:mt-0">
                    {/* Save Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{ height: "25px", borderRadius: "10px" }}
                    >
                        {isLoading ? <CircularProgress size={22} color="inherit" /> : "Update"}
                    </Button>

                    {/* Back to List Button */}
                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/Home"
                        style={{ height: "25px", borderRadius: "10px", marginRight: "5px" }}
                    >
                        Back To List
                    </Button>
                </div>
            </div>
            <div className="w-full flex flex-wrap">
                <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                    <div className="w-full mr-2">
                        <label className="block uppercase tracking-wide text-xs  mb-2" htmlFor="name">
                            Name
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Name' value={formData.Name} onChange={handleChange} type="text" placeholder=" Company name"
                            required
                            maxLength={50}
                        />
                    </div>
                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs  mb-2" htmlFor="name">
                            VAT Number
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='VATNumber' value={formData.VATNumber} onChange={handleChange} type="text" placeholder=" VAT Number" />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs  mb-2" htmlFor="contactNumber1">
                            Contact Number 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='ContactNumber1' value={formData.ContactNumber1} onChange={handleChange} type="text" placeholder=" Contact Number 1"
                            required
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="contactNumber2">
                            Contact Number 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='ContactNumber2' value={formData.ContactNumber2} onChange={handleChange} type="text" placeholder=" Contact Number 2"
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="contactNumber2">
                            Contact Number 3
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='ContactNumber3' value={formData.ContactNumber3} onChange={handleChange} type="text" placeholder=" Contact Number 2"
                            maxLength={15}
                            pattern={phoneNumberPattern.source}
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="email">
                            Email
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Email' value={formData.Email} onChange={handleChange} type="text" placeholder=" Email"
                            maxLength={30}
                            pattern={emailPattern.source}
                        />
                    </div>
                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="name">
                            Address Line 1
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='AddressLine1' value={formData.AddressLine1} onChange={handleChange} type="text" placeholder=" Address Line 1"
                            maxLength={100}
                            required
                        />
                    </div>

                    <div className="w-1/2 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="name">
                            Address Line 2
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='AddressLine2' value={formData.AddressLine2} onChange={handleChange} type="text" placeholder=" Address Line 2"
                            maxLength={100}
                        />
                    </div>
                </div>

                <div className="w-full mb-2 flex">
                    <div className="w-3/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="name">
                            Location
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='Location' value={formData.Location} onChange={handleChange} type="text" placeholder=" Location"
                            maxLength={100}
                            required
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="email">
                            Postal Code
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='PostalCode' value={formData.PostalCode} onChange={handleChange} type="text" placeholder=" Postal Code"
                            maxLength={30}
                        />
                    </div>

                    <div className="w-1/6 mr-2">
                        <label className="block uppercase tracking-wide  text-xs mb-2" htmlFor="email">
                            Cash Opening
                        </label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name='CashOpening' value={formData.CashOpening} onChange={handleChange} type="number" placeholder=" Postal Code"
                        />
                    </div>
                </div>
            </div >
        </div >

    );
};

export default CompanyEdit;
